var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgDeactivatedUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    opacity: 0.5,
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4294 24.0871C29.0484 21.8031 30 19.0127 30 16C30 12.287 28.525 8.72601 25.8995 6.1005C23.274 3.475 19.713 2 16 2C13.2446 2 10.675 2.79604 8.50885 4.17068L9.89627 5.63112C11.7024 4.56568 13.7944 3.9684 15.9869 3.96703C20.9652 3.96391 25.4289 7.03366 27.2073 11.6835C28.6122 15.3567 28.111 19.4138 26.0096 22.5926L27.4294 24.0871ZM23.96 23.5465C23.9915 23.7964 24.0053 24.0517 24 24.311V24.918C24.2289 24.7132 24.4485 24.501 24.6587 24.282L26.0501 25.7466C23.5056 28.3698 19.9432 30 16 30C8.26801 30 2 23.732 2 16C2 11.7987 3.85061 8.02963 6.78114 5.46349L8.13946 6.8933C6.66939 8.16469 5.49923 9.79992 4.7762 11.6975C3.00361 16.3495 4.2861 21.6128 8 24.928V24.343C8 24.3375 8.0025 24.332 8.005 24.3265C8.0075 24.321 8.01 24.3155 8.01 24.31C7.94774 21.4757 10.1673 19.1138 13 19H19C19.243 19.0097 19.4815 19.0359 19.7145 19.0776L23.96 23.5465ZM19.4156 15.6515C20.3907 14.7391 21 13.4407 21 12C21 9.23858 18.7614 7 16 7C14.6515 7 13.4277 7.53384 12.5283 8.40172L19.4156 15.6515ZM11.3186 10.2398L17.518 16.7654C17.0392 16.9178 16.5292 17 16 17C13.2386 17 11 14.7614 11 12C11 11.3805 11.1127 10.7873 11.3186 10.2398Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0318 29.7186L3 4.42187L4.4967 3L28.5286 28.2967L27.0318 29.7186Z",
    fill: "#FF0000"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgDeactivatedUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deactivated_user.a2b0f0278b1f6cc28934250595591bd7.svg";